import Model from "@/lib/model/model";
import { NonessentialComponent } from "@/lib/model/exambuilder/exam-component/common";

export enum ParamType {
  Choice = "choice",
  Choice2 = "choice2",
  City = "city",
  Date = "date",
  Email = "email",
  File = "file",
  IdCard = "idcard",
  Major = "major",
  Multi = "multiChoice",
  Multi2 = "multiChoice2",
  Phone = "phone",
  Range = "range",
  School = "school",
  ShortIdCard = "shortIdCard",
  String = "string",
  Bmi = "bmi",
  Height = "height",
  Weight = "weight"
}

export class MutiChoiceOption extends Model {
  key = ""; // 选项内容
  desc = ""; // 选项描述
  type = ""; // 类型 unsetOthers 与其他选项互斥

  showDesc = false; // 前端用
}

//二级单选
export class Choice2Option extends Model {
  keyList1: string[] = [""]; //一级选项
  keyList2: string[][] = [["", ""]]; //二级选项
  keyList1Chk: string[] = [""]; //复刻一下数据 表单校验用
  keyList2Chk: string[][] = [["", ""]];
}

//条件展示
export class ShowConfig extends Model {
  matchParamId = 0; //父级id 后台
  matchParamIndex = 0; //父级id (为前端新建时)
  matchType = "equal"; //父级类型 多选contains 日期dateToAgeRange
  matchValue = ""; //命中值
  fId = ""; //父字段选项id
}

export class Param extends Model {
  paramId = 0; // 登记信息id 创建场景0修改场景非0
  name = ""; // 登记信息名 姓名/手机 必填
  aliasName = ""; // 候选人答题端别名
  imageUrl = ""; //题目配图
  isShow = 0; // 是否使用 1是
  isRequired = 2; // 是否必填 1是
  paramOcr = 0; // 是否开启拍照辅助识别 1是
  inputType: ParamType = ParamType.String; // 输入类型 姓名->string 手机->phone
  paramIndex = 0;
  fIdList = [""]; //单选选项唯一标识list
  singleChoiceOptions = [""]; // choice -> 单择选项
  mutiChoiceOptions: MutiChoiceOption[] = []; //多选选项
  choice2options = new Choice2Option(); //二级选项
  rangeConfig = {
    rangeMin: 0,
    rangeMax: 0,
    rangeStep: 0
  };
  dateConfig = {
    dateFormat: 0,
    daysLimit: 0
  };
  captchaCheck = 0;
  dateAsAge = 0;
  canUpdate = 1; // 默认可以修改。1为可以修改，0为不可以修改
  saveLater = 0; //后台用 1为登记后
  showConfigList: ShowConfig[][] = [[new ShowConfig()]]; //条件展示

  objectArrayClasses() {
    return {
      mutiChoiceOptions: MutiChoiceOption
    };
  }
}

export class ParamComponent extends NonessentialComponent {
  componentSort = 0;
}

export class CandidateParam {
  paramId?: 0;
  type = 0;
  isShow = 0;
  isRequired = 0;
  inputType: ParamType = ParamType.String;
  sort = 0;
  extraData = "";
  name = "";
  value = "";
  aliasName = ""; //别名
  cascadeValue = "";
}
